import {WithChildren} from '_metronic/helpers'
import {FC} from 'react'
import Drawer from 'react-modern-drawer'
import Button from 'app/components/Button'

type Props = {
  isDrawerOpen: boolean
  onCancel: VoidFunction
  title: string
  loading?: boolean
  submitHandler?: () => void
  submitBtnText?: string
  submitBtnLoadingText?: string
}

const CustomDrawer: FC<Props & WithChildren> = ({
  isDrawerOpen,
  onCancel,
  title,
  loading,
  children,
  submitHandler,
  submitBtnText = 'Save',
  submitBtnLoadingText = 'Saving',
}) => {
  return (
    <Drawer open={isDrawerOpen} onClose={onCancel} direction='right' className='custom-drawer'>
      <div
        className='modal-dialog-centered border-bottom border-gray-300'
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          padding: '14px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          paddingLeft: '15px',
          paddingRight: '12px',
        }}
      >
        <h3 className='text-dark fs-4 fw-bold mx-2' style={{margin: '0'}}>
          {title}
        </h3>

        <div style={{display: 'flex', gap: '16px'}}>
          <div
            className='btn btn-icon btn-sm btn-active-light-primary '
            onClick={onCancel}
            aria-label='Close'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#5A5A5A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-x'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M18 6l-12 12' />
              <path d='M6 6l12 12' />
            </svg>
          </div>
        </div>
      </div>

      <div
        className=' scroll-y overflow-auto mb-4'
        tabIndex={-1}
        style={{
          height: 'calc(100vh - 20px)',
        }}
      >
        {children}
      </div>

      {submitHandler && (
        <div
          className='offcanvas-footer d-flex justify-content-end mb-4 border-top pt-4 pb-3 mx-7'
          style={{position: 'sticky', bottom: 0, backgroundColor: 'white'}}
        >
          {loading ? (
            <Button btnType='primary' disabled>
              <span>{submitBtnLoadingText}</span>
              <span className='spinner-border spinner-border-sm align-middle mx-2'></span>
            </Button>
          ) : (
            <Button btnType='primary' type='submit' onClick={submitHandler}>
              {submitBtnText}
            </Button>
          )}
        </div>
      )}
    </Drawer>
  )
}

export default CustomDrawer
